import { Button } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useUpdateProductTokenURI } from 'src/hooks'

interface IProps {
  disabled: boolean
  locale?: string
}

export const UpdateMetadataButton = ({ disabled, locale }: IProps) => {
  const { mutate, isLoading } = useUpdateProductTokenURI(locale)

  const handleClick = () => {
    mutate()
  }

  return (
    <div>
      <Button variant="contained" onClick={handleClick} disabled={isLoading || disabled}>
        <HelperWrapper t="update-metadata-button-text" isColorInherited verticalPosition={35} />
      </Button>
    </div>
  )
}
